import DeclarationBoxIndividualData from "../variables/variables.json";

import classNames from "classname";
import TranslatedMessage from "./TranslatedMessage";
import Image from "next/image";
import Link from "next/link";

const DeclarationBoxIndividual = (props) => {
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;
	const formattedMessage = "declarationBoxIndividual." + propsPodatek;

	return (
		<>
			<div
				className={classNames("declaration-box-individual", {
					top: props.top,
					"no-shadow": props.noShadow,
				})}
			>
				<div className="declaration-box-individual__container">
					{DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.available && (
						<div className="declaration-box-individual__image">
							<Image
								unoptimized
								alt=""
								className="declaration-box-individual__image__img"
								src={
									DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.one.url
								}
								width={
									DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.one
										.width
								}
								height={
									DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.one
										.height
								}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>

							{DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.two && (
								<Image
									unoptimized
									alt=""
									className="declaration-box-individual__image__img declaration-box-individual__image__img--second"
									src={
										DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.two
											.url
									}
									width={
										DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.two
											.width
									}
									height={
										DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].images.two
											.height
									}
									style={{
										maxWidth: "100%",
										height: "auto",
									}}
								/>
							)}
						</div>
					)}

					<div
						className={classNames("declaration-box-individual__title", {
							bigTitle: props.bigTitle,
						})}
					>
						<TranslatedMessage id={formattedMessage + ".title"} />
					</div>
					<div className="declaration-box-individual__description">
						<TranslatedMessage id={formattedMessage + ".description"} />
					</div>
					{!props.noAction && (
						<div className="declaration-box-individual__button">
							{props.button == "link" && (
								<Link
									className={classNames("declaration-box-individual__button__btn pd-btn", {
										"pd-btn--primary": props.btnPrimary,
										"pd-btn--outline": props.btnOutline,
									})}
									href={DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].action}
									target="_self"
								>
									<TranslatedMessage id={formattedMessage + ".action"} />
								</Link>
							)}

							{props.button == "dialog" && (
								<button
									type="button"
									data-a11y-dialog-show={props.dialogShow}
									aria-haspopup="dialog"
									aria-controls={props.dialogShow}
									className={classNames("declaration-box-individual__button__btn pd-btn", {
										"pd-btn--primary": props.btnPrimary,
										"pd-btn--outline": props.btnOutline,
									})}
								>
									<TranslatedMessage id={formattedMessage + ".action"} />
								</button>
							)}
						</div>
					)}
				</div>
				{!props.noReadMore && (
					<div className="declaration-box-individual__link">
						<Link
							className="declaration-box-individual__link__a"
							href={DeclarationBoxIndividualData.declarationBoxIndividual[propsPodatek].readmore}
							target="_self"
						>
							<p>
								<TranslatedMessage id={formattedMessage + ".readmore"} />
							</p>
						</Link>
					</div>
				)}
			</div>
		</>
	);
};

export default DeclarationBoxIndividual;
